export const unknownArtistSlug = "ad921d60486366258809553a3db49a4a";